import React from 'react';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { ReportStatus } from '@/types/reports';

interface SendStatusBadgeProps {
  status: ReportStatus;
}

const badgeClassName =
  'inline-flex h-5 items-center justify-center gap-1 rounded-lg px-2 py-0.5 text-xs font-semibold leading-4 whitespace-nowrap';

type StatusConfig = {
  label: string;
  className: string;
  iconColor?: string;
  showIcon?: boolean;
};

const STATUS_CONFIG: Record<ReportStatus, StatusConfig> = {
  draft: {
    label: 'Em rascunho',
    className: 'bg-gray-100 text-gray-600',
    iconColor: '#4B5563',
    showIcon: true,
  },
  finished: {
    label: 'Em rascunho',
    className: 'bg-gray-100 text-gray-600',
    iconColor: '#4B5563',
    showIcon: true,
  },
  awaiting_send: {
    label: 'Aguardando envio',
    className: 'bg-[#DBEAFE] text-[#1E40AF]',
    iconColor: '#1E40AF',
    showIcon: true,
  },
  sending: {
    label: 'Enviando',
    className: 'bg-[#FEF3C7] text-[#92400E]',
    iconColor: '#92400E',
    showIcon: true,
  },
  sent: {
    label: 'Enviado',
    className: 'bg-[#DCFCE7] text-[#166534]',
    showIcon: false,
  },
  send_failed: {
    label: 'Falha no envio',
    className: 'bg-[#DC2626] text-white',
    iconColor: '#FEF2F2',
    showIcon: true,
  },
};

export const SendStatusBadge: React.FC<SendStatusBadgeProps> = ({ status }) => {
  const config = STATUS_CONFIG[status] ?? STATUS_CONFIG.awaiting_send;

  return (
    <span className={cn(badgeClassName, config.className)}>
      {config.showIcon ? (
        <Info
          className="h-3 w-3 shrink-0"
          strokeWidth={1.25}
          style={{ color: config.iconColor }}
        />
      ) : null}
      {config.label}
    </span>
  );
};
